'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getTemplate($attrs, $sce) {
    // Default shopping cart call function
    if ($attrs.targetPhase == 'call' && !$attrs.call) {
        $attrs.call = "window.showShoppingBasket()";
    }

    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'winres-reservation-pay-button';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('winres-reservation-pay-button', require('./winresReservationPayButton.html'));
}]);

var WinresReservationPayButtonController = function () {
    function WinresReservationPayButtonController() {
        _classCallCheck(this, WinresReservationPayButtonController);
    }

    _createClass(WinresReservationPayButtonController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.winresReservationContext) {
                if (window.definiteWinresReservationContext) {
                    console.log('[winres-reservation-pay-button]', 'Context is not available. Falling back to global.');
                    this.winresReservationContext = window.definiteWinresReservationContext;
                } else {
                    throw new Error('A context is required.');
                }
            }
        }
    }]);

    return WinresReservationPayButtonController;
}();

_module3.default.component('winresReservationPayButton', {
    templateUrl: getTemplate,
    controller: WinresReservationPayButtonController,
    require: {
        winresReservationContext: '?^^winresReservationContext'
    },
    bindings: {
        // NOTE: This same documentation exists in payButton.js. Keep the
        // comments in sync.
        //
        // Title when moving to payment. E.g. "To payment". Not required.
        // By default, reservation_customer.go_pay is used.
        title: '@',
        // Title to show when the shopping cart sum is 0. E.g. "Confirm booking".
        // By default, reservation_customer.confirm is used.
        titleZeroEur: '@',
        // Defaults to true. In this case, for 0-eur reservations confirmation is
        // made via separate API call (confirmBookingByInvoice)
        payDirectly: '@', // "false" or "NTS"/"VM"/... - default false
        // Defaults to true. In this case, for 0-eur reservations confirmation is
        // made via separate API call (confirmBookingByInvoice)
        canBookZeroEur: '@', // "false" or "true", default "false"
        // "true" or not set. Allows booking by invoice when booking total is NOT set to zero ( 0 ).
        bookByInvoice: '@',
        // "false" (defaul) or payment method code "NTS"/"VM"/"VMLK"/...
        // In this case, targetPhase must be "pay" or empty.
        showErrors: '@', //"true" or "false" - defaults to true
        // Go to this phase when clicked.
        // The following values have aspecial meaning:
        //  "pay" (default). Has special handling for direct payment etc.
        //  "popup". Opends winres-reservation-popup.
        //  "call". Calls window.showShoppingBasket() function.
        targetPhase: '@',
        //Default true.
        showTax: '@',
        errorTimeout: '@', // If null, error stays forever. Also in reservationErrors.js
        // if you don't want errors displayed, make sure to display them in some other place
        noErrors: '@',
        //if true uses modalservice.confirm instead of modalservice.yesNo
        yesNo: '@',
        // default: false;
        hideWhenNoCapacity: '@',

        //asks the terms here, can be also found in winresReservationCustomerInfo and winresReservationPayment
        termsSwitch: '@',
        // Accept terms link. ex. pdf file. Leave empty to open modal.
        openLink: '@',
        // Scope has window. thus, window.$('.shopping-cart').show() works in on-add.
        call: '&'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationPayButton/winresReservationPayButton.js
// module id = 388
// module chunks = 2